/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_First_ListingInputs */

const en_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create First Listing`)
};

const es_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear primer anuncio`)
};

const fr_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer la première annonce`)
};

const de_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstes Inserat erstellen`)
};

const ja_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の出品を作成`)
};

const zh_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建第一个商品`)
};

const ar_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنشئ إعلانك الأول`)
};

const id_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Listing Pertama`)
};

const it_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea il Primo Annuncio`)
};

const ru_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать первое объявление`)
};

const pt_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar Primeiro Anúncio`)
};

const ko_create_first_listing = /** @type {(inputs: Create_First_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 상품 만들기`)
};

/**
* | output |
* | --- |
* | "Create First Listing" |
*
* @param {Create_First_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_first_listing = /** @type {((inputs?: Create_First_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_First_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_first_listing(inputs)
	if (locale === "es") return es_create_first_listing(inputs)
	if (locale === "fr") return fr_create_first_listing(inputs)
	if (locale === "de") return de_create_first_listing(inputs)
	if (locale === "ja") return ja_create_first_listing(inputs)
	if (locale === "zh") return zh_create_first_listing(inputs)
	if (locale === "ar") return ar_create_first_listing(inputs)
	if (locale === "id") return id_create_first_listing(inputs)
	if (locale === "it") return it_create_first_listing(inputs)
	if (locale === "ru") return ru_create_first_listing(inputs)
	if (locale === "pt") return pt_create_first_listing(inputs)
	return ko_create_first_listing(inputs)
});